<template>
    <el-button type="text" @click="jump">{{scope.row[tableData.bind]}}</el-button>
</template>

<script>
    export default {
        name: "detailBtn",
        props: {
            tableData: Object,
            scope: Object
        },
        methods: {
            jump() {
                let url = this.scope.row.level === 1 ?  '/task/taskSubDetail' : '/task/taskDetail'
                this.$router.push({
                    path: url,
                    query: {
                        id: this.scope.row.id
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>
